import React from "react";

function Page5() {
  return (
    <div className="page-container">
      <div
        className="page"
        style={{
          width: "93%",
          height: "1209px",
          margin: "20px auto 20px auto",
          boxShadow: "0 0 2rem 0 rgba(136, 152, 170, 0.5)",
        }}
      >
        <div
          id="pg5Overlay"
          style={{
            WebkitUserSelect: "none",
            backgroundColor: "rgba(0,0,0,0)",
            height: "100%",
            position: "absolute",
            width: "100%",
            zIndex: "1",
          }}
        />
        <div className="text-container">
          <span
            className="t s0"
            style={{
              bottom: "1138px",
              left: "55px",
              letterSpacing: "-0.15px",
            }}
          >
            Form W-9 (Rev. 3-2024){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1137px",
              left: "844px",
              letterSpacing: "-0.14px",
            }}
          >
            Page{" "}
          </span>
          <span
            className="t sb"
            style={{
              bottom: "1135px",
              left: "872px",
            }}
          >
            5{" "}
          </span>
          <span
            className="t sd"
            style={{
              bottom: "1099px",
              left: "55px",
              letterSpacing: "0.14px",
            }}
          >
            Part II. Certification{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1082px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            To establish to the withholding agent that you are a U.S. person, or{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1068px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            resident alien, sign Form W-9. You may be requested to sign by the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1054px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            withholding agent even if item 1, 4, or 5 below indicates otherwise.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1036px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            For a joint account, only the person whose TIN is shown in Part I{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1022px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            should sign (when required). In the case of a disregarded entity,
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "1008px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            person identified on line 1 must sign. Exempt payees, see{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1008px",
              left: "373px",
              letterSpacing: "0.13px",
            }}
          >
            Exempt{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "1008px",
              left: "418px",
              letterSpacing: "0.1px",
            }}
          >
            payee{" "}
          </span>
          <span
            className="t s7"
            style={{
              bottom: "995px",
              left: "55px",
              letterSpacing: "0.12px",
            }}
          >
            code
          </span>
          <span
            className="t s6"
            style={{
              bottom: "995px",
              left: "82px",
              letterSpacing: "0.08px",
            }}
          >
            , earlier.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "976px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            Signature requirements.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "976px",
              left: "199px",
              letterSpacing: "0.1px",
            }}
          >
            Complete the certification as indicated{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "976px",
              left: "413px",
              letterSpacing: "0.06px",
            }}
          >
            in{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "963px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            items 1 through 5 below.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "944px",
              left: "67px",
              letterSpacing: "0.11px",
            }}
          >
            1. Interest, dividend, and barter exchange accounts opened{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "930px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            before 1984 and broker accounts considered active during 1983.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "917px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            You must give your correct TIN, but you do not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "917px",
              left: "315px",
              letterSpacing: "0.09px",
            }}
          >
            have to sign the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "903px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            certification.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "885px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            2. Interest, dividend, broker, and barter exchange accounts{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "871px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            opened after 1983 and broker accounts considered inactive during{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "857px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            1983.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "857px",
              left: "89px",
              letterSpacing: "0.1px",
            }}
          >
            You must sign the certification or backup{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "857px",
              left: "317px",
              letterSpacing: "0.09px",
            }}
          >
            withholding will apply. If{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "843px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            you are subject to backup withholding{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "843px",
              left: "267px",
              letterSpacing: "0.1px",
            }}
          >
            and you are merely providing{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "830px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            your correct TIN to the requester,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "830px",
              left: "240px",
              letterSpacing: "0.1px",
            }}
          >
            you must cross out item 2 in the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "816px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            certification before signing the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "816px",
              left: "224px",
              letterSpacing: "0.1px",
            }}
          >
            form.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "798px",
              left: "67px",
              letterSpacing: "0.1px",
            }}
          >
            3. Real estate transactions.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "798px",
              left: "229px",
              letterSpacing: "0.1px",
            }}
          >
            You must sign the certification.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "798px",
              left: "402px",
              letterSpacing: "0.11px",
            }}
          >
            You may{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "784px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            cross out item 2 of the certification.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "765px",
              left: "67px",
              letterSpacing: "0.11px",
            }}
          >
            4. Other payments.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "765px",
              left: "181px",
              letterSpacing: "0.1px",
            }}
          >
            You must give your correct TIN, but you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "765px",
              left: "402px",
              letterSpacing: "0.09px",
            }}
          >
            do not{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "752px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            have to sign the certification unless you have been{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "752px",
              left: "334px",
              letterSpacing: "0.09px",
            }}
          >
            notified that you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "738px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            have previously given an incorrect TIN. “Other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "738px",
              left: "309px",
              letterSpacing: "0.1px",
            }}
          >
            payments” include{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "724px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            payments made in the course of the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "724px",
              left: "255px",
              letterSpacing: "0.09px",
            }}
          >
            requester’s trade or business for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "710px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            rents, royalties, goods (other{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "710px",
              left: "214px",
              letterSpacing: "0.1px",
            }}
          >
            than bills for merchandise), medical and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "697px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            health care services{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "697px",
              left: "167px",
              letterSpacing: "0.1px",
            }}
          >
            (including payments to corporations), payments to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "683px",
              left: "55px",
            }}
          >
            a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "683px",
              left: "65px",
              letterSpacing: "0.1px",
            }}
          >
            nonemployee for services, payments made in settlement of payment{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "669px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            card and third-party network transactions, payments to certain
            fishing{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "655px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            boat crew{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "655px",
              left: "113px",
              letterSpacing: "0.11px",
            }}
          >
            members and fishermen, and gross proceeds paid to{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "642px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            attorneys{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "642px",
              left: "109px",
              letterSpacing: "0.1px",
            }}
          >
            (including payments to corporations).{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "623px",
              left: "67px",
              letterSpacing: "0.11px",
            }}
          >
            5. Mortgage interest paid by you, acquisition or abandonment of{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "610px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            secured property, cancellation of debt, qualified tuition program{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "596px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            payments (under section 529), ABLE accounts (under section 529A),{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "582px",
              left: "55px",
              letterSpacing: "0.11px",
            }}
          >
            IRA, Coverdell ESA, Archer MSA or HSA contributions or{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "568px",
              left: "55px",
              letterSpacing: "0.1px",
            }}
          >
            distributions, and pension distributions.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "568px",
              left: "289px",
              letterSpacing: "0.11px",
            }}
          >
            You must give your{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "568px",
              left: "398px",
              letterSpacing: "0.09px",
            }}
          >
            correct{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "555px",
              left: "55px",
              letterSpacing: "0.09px",
            }}
          >
            TIN, but you do not have to sign the certification.{" "}
          </span>
          <span
            className="t v4 sd"
            style={{
              bottom: "525px",
              left: "55px",
              letterSpacing: "0.18px",
            }}
          >
            What Name and Number To Give the Requester{" "}
          </span>
          <span
            className="t s3 w-100"
            style={{
              bottom: "507px",
              left: "89px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-36px",
                left: "-35px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            For this type of account:{" "}
            <hr
              className="t s3"
              style={{
                top: "244px",
                left: "175px",
                height: "280px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
            <hr
              className="t s3"
              style={{
                top: "-14px",
                left: "-35px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s3"
            style={{
              bottom: "507px",
              left: "291px",
              letterSpacing: "0.12px",
            }}
          >
            Give name and SSN of:{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "491px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            1. Individual{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "491px",
              left: "273px",
              letterSpacing: "-0.13px",
            }}
          >
            The individual{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "474px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            2. Two or more individuals (joint account){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "462px",
              left: "75px",
              letterSpacing: "-0.14px",
            }}
          >
            other than an account maintained by{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "449px",
              left: "75px",
              letterSpacing: "-0.14px",
            }}
          >
            an FFI{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "474px",
              left: "273px",
              letterSpacing: "-0.13px",
            }}
          >
            The actual owner of the account or,{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "462px",
              left: "273px",
              letterSpacing: "-0.13px",
            }}
          >
            if combined funds, the first individual{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "449px",
              left: "273px",
              letterSpacing: "-0.15px",
            }}
          >
            on the account{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "453px",
              left: "345px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "431px",
              left: "61px",
              letterSpacing: "-0.14px",
            }}
          >
            3. Two or more U.S. persons{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "419px",
              left: "73px",
              letterSpacing: "-0.14px",
            }}
          >
            (joint account maintained by an FFI){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "431px",
              left: "273px",
              letterSpacing: "-0.14px",
            }}
          >
            Each holder of the account{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "401px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            4. Custodial account of a minor{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "388px",
              left: "73px",
              letterSpacing: "-0.13px",
            }}
          >
            (Uniform Gift to Minors Act){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "401px",
              left: "273px",
              letterSpacing: "-0.15px",
            }}
          >
            The minor{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "406px",
              left: "321px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "370px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            5. a. The usual revocable savings trust{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "358px",
              left: "73px",
              letterSpacing: "-0.12px",
            }}
          >
            (grantor is also trustee){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "371px",
              left: "273px",
              letterSpacing: "-0.14px",
            }}
          >
            The grantor-trustee{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "375px",
              left: "366px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "340px",
              left: "73px",
              letterSpacing: "-0.13px",
            }}
          >
            b. So-called trust account that is not{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "328px",
              left: "73px",
              letterSpacing: "-0.13px",
            }}
          >
            a legal or valid trust under state law{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "340px",
              left: "273px",
              letterSpacing: "-0.15px",
            }}
          >
            The actual owner{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "348px",
              left: "355px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "310px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            6. Sole proprietorship or disregarded{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "298px",
              left: "73px",
              letterSpacing: "-0.14px",
            }}
          >
            entity owned by an individual{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "311px",
              left: "273px",
              letterSpacing: "-0.16px",
            }}
          >
            The owner{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "316px",
              left: "323px",
            }}
          >
            3{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "280px",
              left: "61px",
              letterSpacing: "-0.13px",
            }}
          >
            7. Grantor trust filing under Optional{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "268px",
              left: "73px",
              letterSpacing: "-0.14px",
            }}
          >
            Filing Method 1 (see Regulations{" "}
          </span>
          <span
            className="t s0 w-100"
            style={{
              bottom: "255px",
              left: "73px",
              letterSpacing: "-0.12px",
            }}
          >
            section 1.671-4(b)(2)(i)(A))**{" "}
            <hr
              className="t s3"
              style={{
                top: "-10px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s0"
            style={{
              bottom: "280px",
              left: "273px",
              letterSpacing: "-0.14px",
            }}
          >
            The grantor*{" "}
          </span>
          <span
            className="t s3 w-100"
            style={{
              bottom: "1102px",
              left: "518px",
              letterSpacing: "0.1px",
            }}
          >
            <hr
              className="t s3"
              style={{
                top: "-36px",
                left: "-35px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
            For this type of account:{" "}
            <hr
              className="t s3"
              style={{
                top: "274px",
                left: "175px",
                height: "310px",
                width: "1px",
                position: "absolute",
                border: "none",
                backgroundColor: "black",
                transform: "rotate(180deg)",
                transformOrigin: "top left",
                letterSpacing: "0.11px",
              }}
            />
            <hr
              className="t s3"
              style={{
                top: "-14px",
                left: "-35px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s3"
            style={{
              bottom: "1102px",
              left: "722px",
              letterSpacing: "0.11px",
            }}
          >
            Give name and EIN of:{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1085px",
              left: "490px",
              letterSpacing: "-0.14px",
            }}
          >
            8. Disregarded entity not owned by an{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1073px",
              left: "502px",
              letterSpacing: "-0.13px",
            }}
          >
            individual{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1085px",
              left: "702px",
              letterSpacing: "-0.16px",
            }}
          >
            The owner{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1054px",
              left: "490px",
              letterSpacing: "-0.13px",
            }}
          >
            9. A valid trust, estate, or pension trust{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1055px",
              left: "702px",
              letterSpacing: "-0.13px",
            }}
          >
            Legal entity{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "1060px",
              left: "757px",
            }}
          >
            4{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1038px",
              left: "484px",
              letterSpacing: "-0.14px",
            }}
          >
            10. Corporation or LLC electing corporate{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1025px",
              left: "502px",
              letterSpacing: "-0.15px",
            }}
          >
            status on Form 8832 or Form 2553{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1038px",
              left: "702px",
              letterSpacing: "-0.14px",
            }}
          >
            The corporation{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1007px",
              left: "484px",
              letterSpacing: "-0.13px",
            }}
          >
            11. Association, club, religious, charitable,{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "995px",
              left: "502px",
              letterSpacing: "-0.14px",
            }}
          >
            educational, or other tax-exempt{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "983px",
              left: "502px",
              letterSpacing: "-0.14px",
            }}
          >
            organization{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "1007px",
              left: "702px",
              letterSpacing: "-0.14px",
            }}
          >
            The organization{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "964px",
              left: "484px",
              letterSpacing: "-0.15px",
            }}
          >
            12. Partnership or multi-member LLC{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "964px",
              left: "702px",
              letterSpacing: "-0.14px",
            }}
          >
            The partnership{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "948px",
              left: "484px",
              letterSpacing: "-0.14px",
            }}
          >
            13. A broker or registered nominee{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "948px",
              left: "702px",
              letterSpacing: "-0.15px",
            }}
          >
            The broker or nominee{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "931px",
              left: "486px",
              letterSpacing: "-0.14px",
            }}
          >
            14. Account with the Department of{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "918px",
              left: "504px",
              letterSpacing: "-0.13px",
            }}
          >
            Agriculture in the name of a public{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "906px",
              left: "504px",
              letterSpacing: "-0.12px",
            }}
          >
            entity (such as a state or local{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "894px",
              left: "504px",
              letterSpacing: "-0.13px",
            }}
          >
            government, school district, or prison){" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "882px",
              left: "504px",
              letterSpacing: "-0.13px",
            }}
          >
            that receives agricultural program{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "870px",
              left: "504px",
              letterSpacing: "-0.17px",
            }}
          >
            payments{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "931px",
              left: "702px",
              letterSpacing: "-0.13px",
            }}
          >
            The public entity{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "851px",
              left: "486px",
              letterSpacing: "-0.13px",
            }}
          >
            15. Grantor trust filing Form 1041 or{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "839px",
              left: "504px",
              letterSpacing: "-0.13px",
            }}
          >
            under the Optional Filing Method 2,{" "}
          </span>
          <span
            className="t s0"
            style={{
              bottom: "827px",
              left: "504px",
              letterSpacing: "-0.14px",
            }}
          >
            requiring Form 1099 (see Regulations{" "}
          </span>
          <span
            className="t s0 w-100"
            style={{
              bottom: "815px",
              left: "504px",
              letterSpacing: "-0.12px",
            }}
          >
            section 1.671-4(b)(2)(i)(B))**{" "}
            <hr
              className="t s3"
              style={{
                top: "-15px",
                left: "-10px",
                height: "1%",
                width: "42%",
                position: "absolute",
                backgroundColor: "black",
              }}
            />
          </span>
          <span
            className="t s0"
            style={{
              bottom: "851px",
              left: "702px",
              letterSpacing: "-0.13px",
            }}
          >
            The trust{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "797px",
              left: "484px",
            }}
          >
            1{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "790px",
              left: "490px",
              letterSpacing: "0.1px",
            }}
          >
            List first and circle the name of the person whose number you
            furnish.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "776px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            If only one person on a joint account has an SSN, that person’s
            number{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "762px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            must be furnished.{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "749px",
              left: "484px",
            }}
          >
            2{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "743px",
              left: "490px",
              letterSpacing: "0.1px",
            }}
          >
            Circle the minor’s name and furnish the minor’s SSN.{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "731px",
              left: "484px",
            }}
          >
            3{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "724px",
              left: "490px",
              letterSpacing: "0.1px",
            }}
          >
            You must show your individual name on line 1, and enter your
            business{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "712px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            or DBA name, if any, on line 2. You may use either your SSN or EIN
            (if{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "698px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            you have one), but the IRS encourages you to use your SSN.{" "}
          </span>
          <span
            className="t se"
            style={{
              bottom: "685px",
              left: "484px",
            }}
          >
            4{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "679px",
              left: "490px",
              letterSpacing: "0.09px",
            }}
          >
            List first and circle the name of the trust, estate, or pension
            trust. (Do{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "665px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            not furnish the TIN of the personal representative or trustee unless
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "651px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            legal entity itself is not designated in the account title.){" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "633px",
              left: "484px",
            }}
          >
            *{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "633px",
              left: "490px",
              letterSpacing: "0.11px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "633px",
              left: "525px",
              letterSpacing: "0.1px",
            }}
          >
            The grantor must also provide a Form W-9 to the trustee of the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "619px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            trust.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "600px",
              left: "484px",
              letterSpacing: "0.08px",
            }}
          >
            **{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "600px",
              left: "494px",
              letterSpacing: "0.1px",
            }}
          >
            For more information on optional filing methods for grantor trusts,
            see{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "587px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            the Instructions for Form 1041.{" "}
          </span>
          <span
            className="t s3"
            style={{
              bottom: "568px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            Note:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "568px",
              left: "519px",
              letterSpacing: "0.1px",
            }}
          >
            If no name is circled when more than one name is listed,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "568px",
              left: "829px",
              letterSpacing: "0.08px",
            }}
          >
            the{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "555px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            number will be considered to be that of the first name listed.{" "}
          </span>
          <span
            className="t v5 sd"
            style={{
              bottom: "525px",
              left: "484px",
              letterSpacing: "0.17px",
            }}
          >
            Secure Your Tax Records From Identity Theft{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "507px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Identity theft occurs when someone uses your personal information,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "494px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            such as your name, SSN, or other identifying information, without
            your{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "480px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            permission to commit fraud or other crimes. An identity thief may
            use{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "466px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            your SSN to get a job or may file a tax return using your SSN to
            receive{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "452px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            a refund.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "434px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            To reduce your risk:{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "416px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            • Protect your SSN,{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "397px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            • Ensure your employer is protecting your SSN, and{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "379px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            • Be careful when choosing a tax return preparer.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "361px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            If your tax records are affected by identity theft and you receive a{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "347px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            notice from the IRS, respond right away to the name and phone number{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "333px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            printed on the IRS notice or letter.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "315px",
              left: "496px",
              letterSpacing: "0.09px",
            }}
          >
            If your tax records are not currently affected by identity theft but
            you{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "301px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            think you are at risk due to a lost or stolen purse or wallet,
            questionable{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "287px",
              left: "484px",
              letterSpacing: "0.09px",
            }}
          >
            credit card activity, or a questionable credit report, contact the
            IRS{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "274px",
              left: "484px",
              letterSpacing: "0.1px",
            }}
          >
            Identity Theft Hotline at 800-908-4490 or submit Form 14039.{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "255px",
              left: "496px",
              letterSpacing: "0.1px",
            }}
          >
            For more information, see Pub. 5027, Identity Theft Information for{" "}
          </span>
          <span
            className="t s6"
            style={{
              bottom: "241px",
              left: "484px",
              letterSpacing: "0.11px",
            }}
          >
            Taxpayers.{" "}
          </span>
        </div>
      </div>
    </div>
  );
}

export default Page5;
